module.exports = __webpack_public_path__ + "img/4de_Identity-Management.1f826dfc.png";